import { locationLocales } from '@/data/vpnHomeContent';

const localizedNavigation = {
  en: {
    home: 'Home',
    proxies: 'Proxies',
    blog: 'Blog',
    device: 'Device',
    locations: 'Locations',
    getVpn: 'Get Secure VPN',
    getVpnShort: 'Get VPN',
    about: 'About Us',
    disclaimer: 'Disclaimer',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    contact: 'Contact Us',
    footerNote: 'Secure VPN — free VPN for private browsing.',
  },
  ru: {
    home: 'Главная',
    proxies: 'Прокси',
    blog: 'Блог',
    device: 'Устройства',
    locations: 'Страны',
    getVpn: 'Скачать Secure VPN',
    getVpnShort: 'VPN',
    about: 'О нас',
    disclaimer: 'Отказ от ответственности',
    privacy: 'Конфиденциальность',
    terms: 'Условия',
    contact: 'Контакты',
    footerNote: 'Secure VPN — бесплатный VPN для приватного браузинга.',
  },
  ko: {
    home: '홈',
    proxies: '프록시',
    blog: '블로그',
    device: '기기',
    locations: '지역',
    getVpn: 'Secure VPN 받기',
    getVpnShort: 'VPN',
    about: '회사 소개',
    disclaimer: '면책 조항',
    privacy: '개인정보 처리방침',
    terms: '이용약관',
    contact: '문의',
    footerNote: 'Secure VPN — 프라이빗 브라우징을 위한 무료 VPN.',
  },
  hi: {
    home: 'होम',
    proxies: 'प्रॉक्सी',
    blog: 'ब्लॉग',
    device: 'डिवाइस',
    locations: 'लोकेशन',
    getVpn: 'Secure VPN प्राप्त करें',
    getVpnShort: 'VPN',
    about: 'हमारे बारे में',
    disclaimer: 'अस्वीकरण',
    privacy: 'प्राइवेसी नीति',
    terms: 'उपयोग की शर्तें',
    contact: 'संपर्क',
    footerNote: 'Secure VPN — निजी ब्राउज़िंग के लिए मुफ्त VPN.',
  },
  ja: {
    home: 'ホーム',
    proxies: 'プロキシ',
    blog: 'ブログ',
    device: 'デバイス',
    locations: '地域',
    getVpn: 'Secure VPNを入手',
    getVpnShort: 'VPN',
    about: '会社概要',
    disclaimer: '免責事項',
    privacy: 'プライバシーポリシー',
    terms: '利用規約',
    contact: 'お問い合わせ',
    footerNote: 'Secure VPN — プライベートブラウジング向け無料VPN。',
  },
  fr: {
    home: 'Accueil',
    proxies: 'Proxies',
    blog: 'Blog',
    device: 'Appareils',
    locations: 'Pays',
    getVpn: 'Obtenir Secure VPN',
    getVpnShort: 'VPN',
    about: 'À propos',
    disclaimer: 'Avertissement',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    contact: 'Contact',
    footerNote: 'Secure VPN — VPN gratuit pour une navigation privée.',
  },
  'pt-BR': {
    home: 'Início',
    proxies: 'Proxies',
    blog: 'Blog',
    device: 'Dispositivos',
    locations: 'Localidades',
    getVpn: 'Obter Secure VPN',
    getVpnShort: 'VPN',
    about: 'Sobre nós',
    disclaimer: 'Aviso legal',
    privacy: 'Privacidade',
    terms: 'Termos de uso',
    contact: 'Contato',
    footerNote: 'Secure VPN — VPN grátis para navegação privada.',
  },
  es: {
    home: 'Inicio',
    proxies: 'Proxies',
    blog: 'Blog',
    device: 'Dispositivos',
    locations: 'Ubicaciones',
    getVpn: 'Obtener Secure VPN',
    getVpnShort: 'VPN',
    about: 'Sobre nosotros',
    disclaimer: 'Aviso legal',
    privacy: 'Privacidad',
    terms: 'Términos de uso',
    contact: 'Contacto',
    footerNote: 'Secure VPN — VPN gratis para navegación privada.',
  },
  id: {
    home: 'Beranda',
    proxies: 'Proxy',
    blog: 'Blog',
    device: 'Perangkat',
    locations: 'Lokasi',
    getVpn: 'Dapatkan Secure VPN',
    getVpnShort: 'VPN',
    about: 'Tentang Kami',
    disclaimer: 'Penafian',
    privacy: 'Kebijakan Privasi',
    terms: 'Ketentuan Penggunaan',
    contact: 'Kontak',
    footerNote: 'Secure VPN — VPN gratis untuk browsing pribadi.',
  },
};

export function getNavigationCopy(localeKey = 'en') {
  return localizedNavigation[localeKey] || localizedNavigation.en;
}

const locationNavLabels = {
  ru: 'Russia',
  ko: 'Korea',
  hi: 'India',
  ja: 'Japan',
  fr: 'France',
  'pt-BR': 'Brazil',
  es: 'Spain',
  id: 'Indonesia',
};

export function getLocationLinks() {
  return Object.entries(locationLocales).map(([key, item]) => ({
    key,
    label: locationNavLabels[key] || item.label,
    path: item.path,
  }));
}

/** 导航栏语言切换：英文首页 + 8 个多语言落地页 */
export const LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English', short: 'EN', path: '/' },
  ...Object.entries(locationLocales).map(([code, item]) => {
    const nativeLabels = {
      ru: 'Русский',
      ko: '한국어',
      hi: 'हिन्दी',
      ja: '日本語',
      fr: 'Français',
      'pt-BR': 'Português (BR)',
      es: 'Español',
      id: 'Bahasa Indonesia',
    };
    const shortLabels = {
      ru: 'RU',
      ko: 'KO',
      hi: 'HI',
      ja: 'JA',
      fr: 'FR',
      'pt-BR': 'BR',
      es: 'ES',
      id: 'ID',
    };
    return {
      code,
      label: nativeLabels[code] || item.label,
      short: shortLabels[code] || code.toUpperCase(),
      path: item.path,
    };
  }),
];

export function getLanguageOptions() {
  return LANGUAGE_OPTIONS;
}
